import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {Tracking, TrackingEvent} from '@common/tracking'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {useTaskStore} from '@components/my-tasks/tasks-list/task-store'
import {PageService} from '@extensions/page-service'

const TwNonInteractiveContainer = tw.div`
  group
  truncate
  text-xs-regular
  inline-block
`

const TwInteractiveContainer = tw.div`
  group
  truncate
  text-xs-regular
  inline-block
  hover:text-action-hover
  pointer
`

const TwSeparator = tw.span`
  text-grey
  group-hover:text-action-hover
`

export const TaskLocationColumn = () => {
  const [, store] = useTaskStore()

  const locationParts = store.chatLocationParts
  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    const hub = store.taskHub
    const box = hub?.companyId
      ? Sync.get({companyId: hub.companyId})
      : Sync.getCurrentSandbox()
    if (hub) {
      const column = box.get(hub.location) as Hub
      if (column) {
        PageService.goToBoard(column.location, hub.companyId)
        Tracking.send(TrackingEvent.myTasksGoToBoard)
      }
    }
  }

  const locationString = locationParts.join(' » ')

  return (
    <Tooltip
      content={
        locationParts.length > 0 ? locationString : Lang.msg.chat.noBoard
      }
      placement="right"
      zIndex={2}
    >
      {locationParts.length > 0 ? (
        <TwInteractiveContainer onClick={onClick}>
          {locationParts.map((part, index) => {
            return (
              <span key={`${index}-${part}`}>
                {part}
                {index < locationParts.length - 1 && (
                  <TwSeparator>{' » '}</TwSeparator>
                )}
              </span>
            )
          })}
        </TwInteractiveContainer>
      ) : (
        <TwNonInteractiveContainer>
          {Lang.msg.chat.noBoard}
        </TwNonInteractiveContainer>
      )}
    </Tooltip>
  )
}
